export function toChinesNum(num) {
  let changeNum = [
    '',
    '一',
    '二',
    '三',
    '四',
    '五',
    '六',
    '七',
    '八',
    '九',
    '十'
  ]
  // let unit = ['', '十', '百', '千', '万']
  num = parseInt(num)
  let newNum
  if (num >= 10) {
    newNum = changeNum[10] + changeNum[num - 10]
  } else {
    newNum = changeNum[num]
  }
  return newNum
}

function formatNumber(n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}

export  function formatTime2(date) {
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()

  var hour = date.getHours()
  var minute = date.getMinutes()
  var second = date.getSeconds()


  return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute].map(formatNumber).join(':')
}


// WEBPACK FOOTER //
// ./src/utils/index.js